import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import intonationThumbnail from '@/assets/intonation-thumbnail.jpg';
import nervousThumbnail from '@/assets/nervous-shaking-thumbnail.jpg';
import neurochemistryThumbnail from '@/assets/neurochemistry-thumbnail.jpg';

const Blog: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const articles = [
    {
      title: "How to use intonation while presenting (TED talk Case Study)",
      excerpt: "Master the art of vocal variety to keep your audience engaged and make your presentations more impactful.",
      image: intonationThumbnail,
      category: "Video",
      date: "March 15, 2024",
      readTime: "3 min watch",
      slug: "how-to-use-intonation-when-presenting"
    },
    {
      title: "How to Prevent Nervous Shaking while presenting",
      excerpt: "Learn techniques to stay calm, composed, and in control during high-pressure presentations.",
      image: nervousThumbnail,
      category: "Video",
      date: "March 12, 2024",
      readTime: "2 min watch",
      slug: "how-to-prevent-nervous-shaking"
    },
    {
      title: "Neurochemistry of storytelling",
      excerpt: "Discover the science behind compelling narratives and how to use brain chemistry to captivate your audience.",
      image: neurochemistryThumbnail,
      category: "Video",
      date: "March 10, 2024",
      readTime: "3 min watch",
      slug: "neurochemistry-of-storytelling"
    },
    {
      title: "The Power of Storytelling in Business Presentations",
      excerpt: "Discover how to weave compelling narratives that resonate with your audience and drive action.",
      image: "lovable-uploads/a46324d1-bdd9-4d94-8169-5e773aa8d825.png",
      category: "Article",
      date: "February 28, 2024",
      readTime: "7 min read"
    },
    {
      title: "Body Language Secrets of Confident Speakers",
      excerpt: "Unlock the non-verbal communication techniques that amplify your message and build trust.",
      image: "lovable-uploads/b82add1b-0367-4652-b103-5038fbc93b4f.png",
      category: "Video",
      date: "February 20, 2024",
      readTime: "10 min watch"
    },
    {
      title: "Designing Slides That Don't Put People to Sleep",
      excerpt: "Transform your slide decks from boring to brilliant with these proven design principles.",
      image: "lovable-uploads/c8c979c7-a384-4e62-a807-cab83afcbbc1.png",
      category: "Article",
      date: "February 15, 2024",
      readTime: "5 min read"
    }
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="py-20 bg-presintention-light section-padding">
          <div className="container-width">
            <div className="text-center mb-16">
            <span className={`inline-block px-3 py-1 bg-blue-50 text-presintention-accent rounded-full text-sm font-medium mb-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
              Blog
            </span>
              <h1 className={`text-4xl md:text-5xl font-bold mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
                Articles and <span className="text-gradient">Videos</span>
              </h1>
              <p className={`max-w-2xl mx-auto text-presintention-muted text-lg transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
                Expert insights and practical strategies to help you become a more confident, compelling presenter.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-lg shadow-lg overflow-hidden hover-lift transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}
                  style={{ transitionDelay: `${(index + 3) * 100}ms` }}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                      onError={(e) => {
                        e.currentTarget.src = 'lovable-uploads/ce5735e2-b1ec-41e3-a57f-c730a06061c4.png';
                      }}
                    />
                    <span className="absolute top-4 left-4 px-3 py-1 bg-presintention-accent text-white text-xs font-medium rounded-full">
                      {article.category}
                    </span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-presintention-muted mb-3">
                      <span>{article.date}</span>
                      <span>•</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-presintention-dark">
                      {article.title}
                    </h3>
                    <p className="text-presintention-muted mb-4">
                      {article.excerpt}
                    </p>
                    <a 
                      href={article.slug ? `/blog/${article.slug}` : '#'} 
                      className="text-presintention-accent font-medium hover:underline inline-flex items-center"
                    >
                      Read More
                      <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
